
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../../common/client/components/Text';

import { getVlaPodil } from '../../../reducers/vla';

import IfComp from '../IfComp';
import LinkToOpsub from './LinkToOpsub';
import ListInfoLoading from './ListInfoLoading';
import ListInfoNoData from './ListInfoNoData';

const classNames = mergeStyleSets({
    row: {
        paddingLeft: 0,
    },
    opsubName: {
        width: 300
    },
    opsubContainer: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 0
    }
});

const IsknVlaItem = ({isknDate, vlaItem}) => {

    const vlaPodil = getVlaPodil(vlaItem.vla);
    const typrav = (vlaItem.vla.typrav_kod !== '30') ? '*' : '';

    return (
        <Stack horizontal verticalAlign="end" className={classNames.row}>
            <Stack.Item className={classNames.opsubName}>
                <LinkToOpsub isknDate={isknDate} opsub={vlaItem.opsub} />
            </Stack.Item>
            <Text className={classNames.vlaPodil}>{vlaPodil}{typrav}</Text>
        </Stack>
    );
}

const IsknVlaList = ({data, isknDate, loading}) => {

    const vlaItems = data.vla.map(item => {
        return {
            vla: item,
            opsub: data.opsub.reduce((previous, current) => {
                return (current.opsub_id === item.opsub_id)
                    ? current
                    : previous;
            }, null)
        };
    });

    return (
        <Stack className={classNames.vlaContainerCompact}>
            {vlaItems.map(item => {
                return (
                    <IsknVlaItem
                        key={item.vla.vla_id}
                        isknDate={isknDate}
                        vlaItem={item}
                    />
                );
            })}
            <IfComp cond={loading}>
                <ListInfoLoading />
            </IfComp>
            <IfComp cond={(vlaItems.length === 0) && !loading}>
                <ListInfoNoData />
            </IfComp>
        </Stack>
    );
}

export default IsknVlaList;
